export default __webpack_public_path__ + "static/media/gifchat4.e8795bcd.gif";